export const awsConfig = {
	Auth: {
		region: 'eu-central-1',
		userPoolId: 'eu-central-1_MU0JGMWkC',
		userPoolWebClientId: '5cko4kgccfkvi2iocm2vg2icku',
	},
};
